import React from 'react'
import classNames from 'classnames'
import PrintItems from './PrintItems'

class PrintContent extends React.Component {
    render() {
        const {item, ...rest} = this.props
        const {isShipped} = item

        const printContentClassName = classNames({
            PrintContent: true,
            Disabled: isShipped
        })

        return (
            <div className={printContentClassName}>
                <PrintItems {...rest} item={item}/>
            </div>
        )
    }
}

export default PrintContent
